/** @module Apparel/PriceList/UnfreezeAllPrices */
define([
    "dojo/_base/declare",
    "csi/action/Controller"
], function(declare,ActionController) {

    return declare(ActionController, {

        /**
         * Returns confirmation button “Unfreeze”.
         */
        getConfirmButton: function() {
            return "UNFREEZE_PRICE";
        }

    });
});